/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Last_TimeInputs */



/**
* | output |
* | --- |
* | "Last time" |
*
* @param {Practice_Last_TimeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_last_time = /** @type {((inputs?: Practice_Last_TimeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Last_TimeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Vorige keer")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La dernière fois")
	return /** @type {LocalizedString} */ ("Last time")
});